import { Expose, Type } from "class-transformer";
import { ActivityDto } from "../../../../../legacy/services/activity/dtos/activity/activity.dto";
import type { IActivityDto } from "../../../../../legacy/services/activity/dtos/activity/activity.dto.interface";
import { DisabilityDto } from "../../../../../legacy/services/persona/dtos/disability/disability.dto";
import type { IDisabilityDto } from "../../../../../legacy/services/persona/dtos/disability/disability.dto.interface";
import { HouseholdMemberPersonaDto } from "../household-member-persona/household-member-persona.dto";
import type { IHouseholdMemberWithAllDataDto } from "./household-member-with-all-data.dto.interface";

export class HouseholdMemberWithAllDataDto extends HouseholdMemberPersonaDto implements IHouseholdMemberWithAllDataDto {
  @Expose()
  @Type(() => DisabilityDto)
  disabilities!: IDisabilityDto[];

  @Expose()
  @Type(() => ActivityDto)
  activities!: IActivityDto[];

  @Expose()
  isComplete!: boolean;
}
